<template>
  <SecondaryBackground>
    <section class="w-full" v-if="characters">
      <OrderMessageEditor
        :order-uuid="$route.params.uuid"
        :characters="characters"
        :categories="categories"
        @submit="$router.back()"
      />
    </section>
  </SecondaryBackground>
</template>

<script>
  import SecondaryBackground from "@/components/common/layout/SecondaryBackground"
  import OrderMessageEditor from "@/components/OrderMessageEditor"
  import Api from "@/api/api_v1.0"

  export default {
    components: { OrderMessageEditor, SecondaryBackground },
    data() {
      return {
        characters: [],
        categories: [],
      }
    },
    async mounted() {
      this.categories = await Api.getCategoriesForOrder(this.$route.params.uuid)
      this.characters = await Api.getCharactersForOrder(this.$route.params.uuid, true)
    }
  }
</script>
